import React, { useEffect } from 'react';
import { Grid, Typography } from '@material-ui/core'
import { ExitButton } from "../../../utils/etc";

function getModalStyle() {
    return {
      top: `50%`,
      left: `50%`,
      transform: `translate(-50%, -50%)`,
    };
}

const SummaryModal=(props)=>{
    const modal = props.modalClasses;
    console.log("modal",modal)
    const closeModal = props.closeModal
    const [modalStyle] = React.useState(getModalStyle);
    console.log("PropsSummary",props);
    console.log("PropsSummary",props.pax.passengers);
    const inputString = '01 CTCM-1 3477032313[TJ]';
    const parts = inputString.split(' ');
    const extractedNumber = parts[2];
    console.log("extractedNumber",extractedNumber);
    return (
        <div style={modalStyle} className={modal.paperBasic}>
          <ExitButton exit={closeModal} />
          <h2 id="simple-modal-title" style={{textAlign: 'center'}}>Summary for {props.pax.FlightNumber} ({props.pax.TailNumber})</h2>
          <Grid className={modal.bg0} item xs={12}>
            {props.pax.passengers.map((passenger, index) => (             
                <Typography key={index} className='mainsummary'>
                <span className='summarypassenger'>{passenger.FirstName}&nbsp;{passenger.LastName}</span>
                {/* <span className='summarypassenger'>{passenger.Mobile.split(' ')[2]}</span> */}
                <span className='summarypassenger passengerweight'>{passenger.Weight}</span>
                </Typography>
            ))}
          </Grid>
          
        </div>
      )

}


export default SummaryModal;